import { useState, useEffect } from "react";
import { navys_for_route } from "../utils/api/navys_for_route.js";
import { get_sailings } from "../utils/api/get_sailings.js";
import { NavySearchCard } from "../components/navySearchCard";
import { SailingCard } from "../components/sailingCard";

export function Select({ searchData, changeSection, setSelectedSailing, setSelectedSailingBack, selectedSailing}) {
  const [navys, setNavys] = useState([]);
  const [searchStatus, setSearchStatus] = useState("searching");

  // Datos de las idas y las vueltas de todos los barcos
  const [sailingsData, setSailingsData] = useState([]);
  const [sailingsDataBack, setSailingsDataBack] = useState([]);
  // Flags que controlan si la ida y la vuelta están seleccionadas
  const [sailingSelected, setSailingSelected] = useState(false);
  const [sailingSelectedBack, setSailingSelectedBack] = useState(false);


  const selectSailing = (sailing) => {
    if(sailing !== null) {
      setSailingSelected(true)
      setSelectedSailing(sailing);
      document.getElementById('back-sailings').scrollIntoView({ behavior: "smooth"})
    }else{
      setSailingSelected(false)
      setSelectedSailing(null);
    }

  };


  const selectSailingBack = (sailing) => {
    if(sailing !== null) {
      setSailingSelectedBack(true)
      setSelectedSailingBack(sailing);
      document.getElementById('buy-button-container').scrollIntoView({ behavior: "smooth"})
    }else{
      setSailingSelectedBack(false)
      setSelectedSailingBack(null);
    }
  };

  const showContinueButton = () => {
    if (searchData.way == 'one_way' && sailingSelected) {
      return <div id="buy-button" className="btnOrange-l btnArrow-l" onClick={handleBuyButton}>Comprar</div>
    }
    else if(sailingSelectedBack) {
      return <div id="buy-button" className="btnOrange-l btnArrow-l" onClick={handleBuyButton}>Comprar</div>
    }
  }

  const handleBuyButton = () => {
    changeSection("data");
  }




  useEffect(() => {
    // Necessary for checking if is currently mounted, preventing memory leaks/updating state on unmounted components
    let isMounted = true;
  
    const fetchNavysAndSailings = async () => {
      if (searchData !== undefined && navys.length === 0) {
        try {
          // Fetch navys
          const fetchedNavys = await getNavys(searchData.origen, searchData.destiny);
          // If component is still mounted, update the navy state
          if (isMounted) {
            setNavys(fetchedNavys);
          }
  
          // Fetch sailings for all navys
          const sailingPromises = fetchedNavys.map((element) => {
            const sailings = get_sailings(element, searchData)
              .then((sailings) => {
                if (isMounted) {
                  console.log("Sailings: ", sailings);
                  paintSailings(sailings);
                }
              })
            return sailings;
          });
          
          
          await Promise.all(sailingPromises);
  
          if (isMounted) {
            setSearchStatus("done");
          }
        } catch (error) {
          console.error("Error fetching navys or sailings: ", error);
          if (isMounted) {
            setSearchStatus("error");
          }
        }
      }
    };
  
    fetchNavysAndSailings();
  
    // Cleanup
    return () => {
      isMounted = false;
    };
  }, [searchData]);

  async function getNavys(origen, destiny) {
    const navys_for_search = await navys_for_route(origen, destiny); // @Angel - please use camelCase in React/JavaScript
    return navys_for_search;
  }

  function timeToInteger(time) {
    const timeArray = time.split(":");
    const hours = parseInt(timeArray[0])*100;
    const minutes = parseInt(timeArray[1]);
    return hours + minutes;
  }

  function paintSailings(new_sailings) {

     setSailingsData((currentData) => {
      const all_data = [...currentData, ...new_sailings.data.go].sort((a, b) => {
        const time1 = timeToInteger(a.outward_time);
        const time2 = timeToInteger(b.outward_time);

        return time1 - time2;
      });
      return all_data})

      setSailingsDataBack((currentData) => {
        const all_data = [...currentData, ...new_sailings.data.back].sort((a, b) => {
          const time1 = timeToInteger(a.outward_time);
          const time2 = timeToInteger(b.outward_time);
  
          return time1 - time2;
        });
        return all_data})
  // setSailingsData((currentData) => [...currentData, ...new_sailings.data.go])   
  }


  return (
    <>
      <div className="t-resBu">
        <div className="o-stepMax">
          <div className="container">
            <div className="o-stepMax__loop">
              <div className="step ">
                <div>
                  <span>1</span>
                </div>
                <div>
                  <span>Buscar ferry</span>
                </div>
              </div>
              <div className="arrow active"></div>
              <div className="step active">
                <div>
                  <span>2</span>
                </div>
                <div>
                  <span>Selecciona tu viaje</span>
                </div>
              </div>
              <div className="arrow "></div>
              <div className="step ">
                <div>
                  <span>3</span>
                </div>
                <div>
                  <span>Datos personales</span>
                </div>
              </div>
              <div className="arrow "></div>
              <div className="step ">
                <div>
                  <span>4</span>
                </div>
                <div>
                  <span>Finalizar compra</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="total content-section bg-b-BluePolar">
          <div className="container o-loopCards">
            <div className="o-cardTicket">
              <div className="bx">
                <div className="row">
                { navys.map((element) => (<NavySearchCard key={element} navy={element} status={searchStatus} />)) }
                </div>
              </div>
            </div>
            <div>
              { sailingsData.map((element, index) => (<SailingCard key={index} data={element} selectSailing={selectSailing} selectSailingBack={selectSailingBack} sailingSelected={sailingSelected} sailingSelectedBack={sailingSelectedBack} way={"go"} selectedSailing={selectedSailing}/>)) }
            </div>
            <br></br><br></br>
            <div id="back-sailings">
              { sailingsDataBack.map((element, index) => (<SailingCard key={index} data={element} selectSailing={selectSailingBack} selectSailingBack={selectSailingBack} sailingSelected={sailingSelectedBack} sailingSelectedBack={sailingSelectedBack} way={"back"} selectedSailing={selectedSailing}  />)) }
            </div>
          </div>
        </div>

        <div className="total content-section t-resBu__foo">
          <div id="buy-button-container" className="container">
            <p className="a-titAlert">Cancelación y modificaciones de horarios gratuitas * según condiciones</p>
            {showContinueButton()}
          </div>
            
        </div>
      </div>
    </>
  );
}